export const MAX_MEDIA_FILES = 5;

export const MAX_AUDIO_FILES = 1;

export const MAX_POST_CHARS = 20000;

export const MAX_RECORDING_SECONDS = 15 * 60;

export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png'] as const;

export const ACCEPTED_AUDIO_TYPES = [
  'audio/m4a',
  'audio/mp4',
  'audio/x-m4a',
  'audio/mpeg',
] as const;

// Images and audio are uploaded directly to S3; video is attached through the
// shared Mux library modal, so the composer's file picker accepts images and
// audio only.
export const ACCEPTED_UPLOAD_TYPES = [
  ...ACCEPTED_IMAGE_TYPES,
  ...ACCEPTED_AUDIO_TYPES,
] as const;
